<template>
  <v-form ref="step4Form"
          v-model="valid"
          lazy-validation>
    <v-row>
      <v-col cols="12">
        <h3 class="text-left">在推廣初期，只要註冊後即享有一個月試用，您可以於此階段使用所有功能並且完全免費。但在第二個月後我們將收取訂閱費，請問您願意花費多少錢加入訂閱？</h3>
        <h4 class="text-left mt-3">選擇偏好方案</h4>
        <v-chip-group v-model="pricingPackageSelected"
                      active-class="blue--text text--accent-3"
                      column
                      mandatory>
          <v-chip v-for="(pricingPackage, index) in pricingPackages"
                  :key="index">
            {{ pricingPackage.title }}
          </v-chip>
        </v-chip-group>
        <h4 class="text-left"
            v-show="!isUnwantedReason">選擇價位</h4>
        <v-chip-group v-model="pricingPackagePrice"
                      v-show="!isUnwantedReason"
                      active-class="blue--text text--accent-3"
                      column
                      mandatory>
          <v-chip v-for="(price, index) in pricingPackages[pricingPackageSelected].price"
                  :key="index">
            <div>{{ price }} 元</div>
          </v-chip>
        </v-chip-group>
        <v-textarea v-show="isUnwantedReason"
                    v-model="unwantedReason"
                    label="請問原因是？"
                    height="150"
                    outlined
                    class="mt-2"></v-textarea>
      </v-col>
    </v-row>

    <v-btn text
           @click="previousStep">
      上一步
    </v-btn>

    <v-btn color="primary"
           @click="nextStep">
      下一步
    </v-btn>
  </v-form>
</template>

<script>
import { db } from '../plugins/db'
const fStore = db.firestore()

export default {
  name: 'Step4',
  props: {
    userId: String,
    showOfflineClasses: Boolean,
    showOnlineClasses: Boolean
  },
  data () {
    return {
      step: 4,
      valid: true,
      pricingPackageSelected: 0,
      pricingPackagePrice: 0,
      pricingPackages: [
        {
          id: 1,
          title: '月訂閱方案',
          price: [
            300,
            600,
            900,
            1200
          ]
        },
        {
          id: 2,
          title: '季訂閱方案',
          price: [
            1200,
            1800,
            2400,
            3000
          ]
        },
        {
          id: 3,
          title: '半年訂閱方案',
          price: [
            2160,
            2970,
            3780,
            4590
          ]
        },
        {
          id: 4,
          title: '年訂閱方案',
          price: [
            3600,
            4800,
            5760,
            6720
          ]
        },
        {
          id: 5,
          title: '我不願意參與訂閱',
          price: []
        }
      ],
      unwantedReason: ''
    }
  },
  computed: {
    isUnwantedReason () {
      return this.pricingPackageSelected === 4
    }
  },
  methods: {
    nextStep () {
      const preferPricing = {}

      if (!this.isUnwantedReason) {
        preferPricing.pricingPackages = this.pricingPackages[this.pricingPackageSelected].title
        preferPricing.pricingPackagePrice = this.pricingPackages[this.pricingPackageSelected].price[this.pricingPackagePrice]
      } else {
        preferPricing.unwantedReason = this.unwantedReason
      }

      fStore.collection('form-1').doc(this.userId).update({
        preferPricing: preferPricing,
        endedAt: new Date()
      }).then(() => {
        this.$emit('goToStep', this.step + 1)
      })
    },
    previousStep () {
      if (this.showOfflineClasses || this.showOnlineClasses) {
        this.$emit('goToStep', this.step - 1)
      } else {
        this.$emit('goToStep', this.step - 2)
      }
    }
  }
}
</script>
